import { render } from "./AdminSplcl.vue?vue&type=template&id=23e5f38b"
import script from "./AdminSplcl.vue?vue&type=script&lang=js"
export * from "./AdminSplcl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__